import React, { useState } from "react";
import { Box, Paper } from "@mui/material";
import useQuestionNavigatorStyle from "../testStyle/iitStyle/questionNavigatorStyle";
import { useQuestionNavigator } from "../../../hooks/iit/useQuestionNavigator";
import InfoPanel from "./InfoPanel";
import QuestionGrid from "./QuestionGrid";
import CollapseToggle from "./CollapseToggle";

const QuestionNavigator = ({
  questionData,
  setCurrentQuestion,
  currentQuestion,
  subjectId
}) => {
  const classes = useQuestionNavigatorStyle();
  const [open, setOpen] = useState(true);

  const {
    questions,
    answered,
    marked,
    notVisited,
    notAnswered,
    markedWithAnswered,
  } = useQuestionNavigator({ questionData, currentQuestion });

  return (
    <Box
      display="flex"
      sx={{ paddingTop: { xs: "0px", sm: "50px" }, height: "100%" }}
    >
      <Box sx={{ marginTop: 25 }}>
        <Box
          sx={{
            background: "black",
            height: 50,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CollapseToggle open={open} setOpen={setOpen} />
        </Box>
      </Box>

      <Paper
        className={classes.root}
        // elevation={3}
        sx={{
          width: open ? "300px" : "0px",
          minWidth: open ? "300px" : "0px",
          overflow: "hidden",
          padding: open ? "10px" : "0px",
          borderLeft: open ? "1px solid #ccc" : "none",
          transition: "all 0.3s ease",
          display: "flex",
          flexDirection: "column",
          // height: "100%",
        }}
      >
        {open && (
          <>
            <InfoPanel
              notVisited={notVisited}
              notAnswered={notAnswered}
              answered={answered}
              marked={marked}
              markedWithAnswered={markedWithAnswered}
              currentQuestion={currentQuestion}
            />

            <Box className={classes.questionGridWrapper}>
              <QuestionGrid
                currentQuestion={currentQuestion}
                questions={questions}
                setCurrentQuestion={setCurrentQuestion}
                subjectId={subjectId}
                questionData={questionData}
              />
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default QuestionNavigator;
